import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-grey-lighten-4 text-subtitle-1 font-weight-bold w-100 pa-2" }
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_4 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_5 = {
  href: "mailto:bizdev@codereadr.com?subject=Requesting Custom Reporting",
  class: "d-block text-decoration-none w-100"
}

import TaskHelperService from '../service/TaskHelperService';
import crApi from "../service/CrApi";
import securityService from "../service/SecurityService";
import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportCsvFilterComponent',
  props: {
  title : {
    type: String,
    default: 'Export a CSV File'
  },
  showTitle : {
    type: Boolean,
    default: true
  },
  selectedTemplate : {
    type: String,
    default: 'regular'
  },
  showTemplate : {
    type: Boolean,
    default: true
  },
  showEmailDownloadBtn : {
    type: Boolean,
    default: true
  },
  showCsvDownloadLink : {
    type: Boolean,
    default: true
  },
  showReportingBtn : {
    type: Boolean,
    default: true
  },
  scanFilterStateV2 : {
    type: Object,
  }
},
  setup(__props) {

const props = __props;

const panel = ref(false);

const computedTemplate = computed({
  get: () => props.scanFilterStateV2.settings.template.id,
  set: (value) => {
    props.scanFilterStateV2.settings.template.id = value;
  }
});

const exportData = async (type: any) => {
  TaskHelperService.modalPlaceholder = 'Please wait...';
  let scanFilter = props.scanFilterStateV2.getParameters();
  let adapterConfig = {};
  let adapterDetails = {};
  let params = {};

  if (type === 'email') {
    adapterConfig['adapterType'] = 'email';

    let adminResponse = await crApi.requestV2('admin/retrieve/', {
      website_token: securityService.getToken()
    });
    if (adminResponse.status === 1) {
      adapterDetails['email'] = adminResponse['admin'][0]['username'];
    }
  }
  params['scanFilter'] = scanFilter;
  if (adapterDetails) {
    adapterConfig['adapterDetails'] = adapterDetails;
  }
  if (adapterConfig) {
    params['adapterConfig'] = adapterConfig;
  }
  params['website_token'] = securityService.getToken();
  let action = type === 'email' ? 'create_export_scan/queue' : 'create_download_scan/queue';
  let response = await crApi.requestV2(`task/${action}/`, params);
  if (response.status === 1) {
    let historyId = response.historyId;
    TaskHelperService.showModal(historyId);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_template_list = _resolveComponent("template-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_csv_download_link = _resolveComponent("csv-download-link")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mb-2 mt-2",
    variant: "text"
  }, {
    default: _withCtx(() => [
      (__props.showTitle)
        ? (_openBlock(), _createBlock(_component_v_card_title, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (__props.showTemplate)
            ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                key: 0,
                variant: "accordion",
                multiple: "",
                modelValue: panel.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((panel).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel, {
                    class: "bg-grey-lighten-4 my-2",
                    elevation: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel_title, {
                        class: "font-weight-bold px-0 my-n3 text-body-2",
                        "hide-actions": ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_v_icon, {
                              class: "mt-n1",
                              size: "large",
                              icon: panel.value ? 'mdi-menu-down' : 'mdi-menu-right'
                            }, null, 8 /* PROPS */, ["icon"]),
                            _createVNode(_component_v_icon, { icon: "mdi-file-export" }),
                            _createTextVNode(" Export template ")
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_expansion_panel_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_template_list, {
                              modelValue: computedTemplate.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((computedTemplate).value = $event)),
                              "field-container-title": 'Your CSV export will contain the following columns:',
                              label: 'Output Format:',
                              "additional-options": {'regular': 'All Data except properties (default)', 'regwithprops': 'All Data (including properties)'}
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"]))
            : _createCommentVNode("v-if", true),
          (__props.showEmailDownloadBtn)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "pr-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "text-none",
                        color: "black",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (exportData('email')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Email Data")
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, { class: "text-right pl-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        class: "text-none",
                        color: "black",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (exportData('download')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Download Data")
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          (__props.showCsvDownloadLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_csv_download_link, { "scan-filter-state-v2": __props.scanFilterStateV2 }, null, 8 /* PROPS */, ["scan-filter-state-v2"])
              ]))
            : _createCommentVNode("v-if", true),
          (__props.showReportingBtn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("a", _hoisted_5, [
                  _createVNode(_component_v_btn, {
                    color: "black",
                    class: "w-100 text-none"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Request Custom Reporting")
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})